var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_vm._v("\n  Sorry, Not Found the Page :)\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }